import { render, staticRenderFns } from "./BotGraph.vue?vue&type=template&id=84b46144&scoped=true&"
import script from "./BotGraph.vue?vue&type=script&lang=js&"
export * from "./BotGraph.vue?vue&type=script&lang=js&"
import style0 from "./BotGraph.vue?vue&type=style&index=0&id=84b46144&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b46144",
  null
  
)

export default component.exports